import { useEffect, useState } from "react";
import { adminApi } from "@/admin/AdminAuthContext";

export const BLANK_GALLERY_ITEM = { title: "", image_url: "", category: "", brand: "", featured: false };

/**
 * Owns all Gallery CRUD state and API calls for the Admin Gallery page --
 * mirrors useAdminBlogPosts.js's pattern of separating business logic
 * from UI rendering.
 */
export const useAdminGalleryItems = () => {
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = () => adminApi.get("/gallery").then((res) => setItems(res.data)).finally(() => setLoading(false));

  useEffect(() => {
    load();
  }, []);

  const openNew = () => setEditing({ ...BLANK_GALLERY_ITEM });
  const close = () => setEditing(null);

  const save = async (e) => {
    e.preventDefault();
    await adminApi.post("/gallery", editing);
    close();
    load();
  };

  const remove = async (id) => {
    if (!window.confirm("Remove this item?")) return;
    await adminApi.delete(`/gallery/${id}`);
    load();
  };

  const updateEditingField = (field, value) => setEditing((prev) => ({ ...prev, [field]: value }));

  return { items, editing, loading, openNew, close, save, remove, updateEditingField };
};
